class FormattingRule {
    id: number;
    name: string;
    scales: Array<FormattingRuleScale>;
    startValue: number; //just to show the gauge properly
    endValue: number;   //just to show the gauge properly
    config: FormattingRuleConfig;
    externalId: number;
    dxLinearGaugeOptions: any;
    organisationId: number;
    companyId: number;

    displayName: KnockoutObservable<string>;

    constructor(data) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? "New Formatting Rule";
        this.displayName = ko.observable(this.name);
        this.startValue = data?.startValue ?? 0;
        this.endValue = data?.endValue ?? 100;
        this.externalId = data?.externalId ?? 0;
        this.config = new FormattingRuleConfig(data?.config);
        this.scales = createInstancesWithParameterFirst(FormattingRuleScale, this, data?.scales ?? []);
        if (!data) { 
            this.scales.push(new FormattingRuleScale(this, { name: "Bad", color: "#D64554", minValue: 0 }));
            this.scales.push(new FormattingRuleScale(this, { name: "Neutral", color: "#D9B300", minValue: 50 }));
            this.scales.push(new FormattingRuleScale(this, { name: "Good", color: "#1AAB40", minValue: 100 }));
        }

        this.organisationId = data?.organisationId ?? null;
        this.companyId = data?.companyId ?? null;

        this.calculateMaxMinValues();
    }

    save(newFormattingRule: boolean = false, sucessCallback: Function = null) {
        var model = {
            newFormattingRule: newFormattingRule,
            formattingRule: ko.toJS(this),
        };
        this.scales = this.scales.sort(this.sortScalesByMinValue);
        let self = this;

        let o = {
            url: urlConfigs.formattingRules + "Save",
            data: model,
            dataType: "json",
            async: false,
        } as RequestServerParams
        o.successFunction = function (data) {
            self.displayName(self.name);

            if (model.newFormattingRule) {
                self.id = data.id;
            }

            if (sucessCallback) {
                sucessCallback(data);
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to save formating rule";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);

        this.calculateMaxMinValues();
    }

    delete(sucessCallback: Function = null, failureFunction: Function = null) {
        let o = {
            url: urlConfigs.formattingRules + "Delete",
            data: { id: this.id },
            dataType: "json",
            async: false,
        } as RequestServerParams
        o.successFunction = function (data) {
            if (data.status) {
                sucessCallback?.();
            }
            else {
                failureFunction?.(data.returnMessage);
            }
        };
        o.failureFunction = function(textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to delete formatting rule";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);

            failureFunction?.(`${errorItem.userMessage} - ${textStatus}`);
        };

        irGlobal.requestServer(o);
    }

    sortScalesByMinValue(firstEl, secondEl) {
        if (firstEl.minValue > secondEl.minValue)
            return 1;
        else
            return firstEl.minValue < secondEl.minValue ? - 1 : 0;
    };

    calculateMaxMinValues() {
        let self = this;
        self.scales.forEach(function (scale: FormattingRuleScale, index: number) {
            if (index === 0)
                self.startValue = scale.minValue;
            scale.startValue = scale.minValue;
            scale.endValue = index === self.scales.length - 1
                ? scale.minValue + (scale.minValue - self.startValue) / index
                : self.scales[index + 1].minValue;
            self.endValue = scale.endValue;
        });
    }
}